import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

export const getOptionSearch = async ({ q = "", brand = "", season = "", category = "" } = {}) => {
	const { data } = await pythonVmInstance.get("/size_contribution/option-search", { params: { q, brand, season, category } });
	return data?.result || [];
};

export const getOptionDetail = async (optionCode) => {
	const { data } = await pythonVmInstance.get(`/size_contribution/option/${encodeURIComponent(optionCode)}`);
	return data?.result;
};

export const getSizeContributionReport = async ({
	optionCode,
	optionCodes = [],
	currentSeason,
	prevSeasonCount,
	filterBrand = "",
	filterCategory = "",
	salesFilters = null,
}) => {
	const body = {
		option_code: optionCode,
		option_codes: optionCodes,
		current_season: currentSeason,
		prev_season_count: prevSeasonCount,
		filter_brand: filterBrand,
		filter_category: filterCategory,
	};
	if (salesFilters && typeof salesFilters === "object") {
		body.sales_filters = salesFilters;
	}
	const { data } = await pythonVmInstance.post("/size_contribution/report", body);
	return data?.result;
};

export const getAttrConfig = async ({ brand, category }) => {
	const { data } = await pythonVmInstance.get("/size_contribution/attr-config", { params: { brand, category } });
	return data?.result;
};

export const putAttrConfig = async ({ brand, category, attributes, updatedBy }) => {
	const { data } = await pythonVmInstance.put("/size_contribution/attr-config", {
		brand,
		category,
		attributes,
		updated_by: updatedBy,
	});
	return data?.result;
};

export const getAttrOptions = async () => {
	const { data } = await pythonVmInstance.get("/size_contribution/attr-options");
	return data?.result || [];
};

export const getFilterOptions = async () => {
	const { data } = await pythonVmInstance.get("/size_contribution/filter-options");
	return data?.result || { brand: [], season: [], category: [] };
};

/** Dependent EBO/MBO/LFS sales-scope options (store / state / region) from BigQuery snapshot. */
export const getSalesFilterOptions = async ({ channel = [], store = [], state = [] } = {}) => {
	const params = {};
	if (channel?.length) params.channel = channel.join(",");
	if (store?.length) params.store = store.join(",");
	if (state?.length) params.state = state.join(",");
	const { data } = await pythonVmInstance.get("/size_contribution/sales-filter-options", { params });
	if (data?.status === "error") {
		throw new Error(data?.message || "sales-filter-options failed");
	}
	return data?.result || { channels: ["EBO", "MBO", "LFS"], stores: [], states: [], regions: [] };
};

export const getAllAttrConfigs = async () => {
	const { data } = await pythonVmInstance.get("/size_contribution/attr-configs");
	return data?.result || [];
};
